import React, { useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { TextField, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Select, MenuItem, InputLabel, Typography, Box } from '@mui/material';
import { HttpRequestContext, getBaseDomain } from '../../../Blocks/HttpRequestProvider';

import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
/* global gtag */


export default function FormPage() {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const theme = useTheme();
    const navigate = useNavigate(); // Hook for navigation
    const baseDomain = getBaseDomain();
    const [isSubmitted, setIsSubmitted] = useState(false);  // State to track if the form has been submitted

    const { sendRequestWithToast } = useContext(HttpRequestContext);


    const onSubmit = data => {

        sendRequestWithToast({
          apiPath: '/form',
          type: 'POST',
          request: data,
          successMessage: "Votre demande a été enregistrée avec succès.",
          errorMessage: "Une erreur est survenue lors de l'envoi du formulaire."
      });

      setIsSubmitted(true);  // Set to true upon successful submission
      sendConversionToGTM();
    };

    const handleRedirect = (url) => {
      window.location.href = url;  // Directly change the browser's location
    };

    const sendConversionToGTM = () => {
      var callback = function () {
      };
  
      gtag('event', 'conversion', {
      'send_to':  "AW-862290376/9yOlCMK_yKUYEMiDlpsD",
      'event_callback': callback
      })
      console.log("Conversion has been sent");
    };


    if (isSubmitted) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100"
                 style={{ 
                   backgroundImage: 'url(/assets/images/testbackground-plan-de-travail-8.svg)',
                   backgroundSize: 'cover',
                   backgroundPosition: 'center'
                 }}>
                <div className="bg-white shadow-lg rounded-lg px-8 pt-6 pb-8 mb-4 text-center max-w-2xl w-full">
                    <Box className="flex items-center justify-center space-x-4 mb-8">
                      <img src="/assets/images/logo2.svg" alt="Logo Innovaplus" className="h-20 w-20" />
                      <h1 className="ml-3 font-bold text-3xl" style={{ color: theme.palette.primary.main }}>Innovaplus</h1>
                    </Box>

                    <Box className="mb-12">
                      <Typography variant="h5" component="h2" className="mb-4 font-bold">
                          Demande reçue avec succès
                      </Typography>
                      <div className="flex justify-center mb-6">
                        <img src="/assets/images/business-meeting-over-coffee-1256x820.jpg" 
                             alt="Confirmation" 
                             className="w-64 h-48 object-cover rounded-lg shadow-md" />
                      </div>
                      <Typography variant="body1" className="mb-4">
                          Nous analyserons votre projet et vous contacterons sous 24-48h pour discuter des solutions adaptées à vos besoins professionnels.
                      </Typography>
                    </Box>

                    <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
                      {/* Button to return to the homepage */}
                      <Button 
                        variant="contained" 
                        color="primary"   
                        onClick={() => handleRedirect(`//${baseDomain}/`)}
                        sx={{ 
                          py: 1.5, 
                          px: 4, 
                          fontWeight: 'bold',
                          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                        }}
                      >
                          Retour à l'accueil
                      </Button>

                      {/* Button to go to the blog */}
                      <Button 
                        variant="outlined" 
                        color="primary" 
                        onClick={() => handleRedirect(`//${baseDomain}/articles`)} 
                        className="mt-4"
                        sx={{ 
                          py: 1.5, 
                          px: 4, 
                          fontWeight: 'bold'
                        }}
                      >
                          Visitez notre Blog
                      </Button>
                    </div>
                    
                    <Box className="mt-12 flex justify-center">
                      <div className="flex space-x-4">
                        <img src="/assets/images/clients/logo1.ico" alt="Client 1" className="h-10 w-auto" />
                        <img src="/assets/images/clients/logo2.svg" alt="Client 2" className="h-10 w-auto" />
                        <img src="/assets/images/clients/logo4.png" alt="Client 3" className="h-10 w-auto" />
                      </div>
                    </Box>
                </div>
            </div>
        );
    }



    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4" 
           style={{ 
             backgroundImage: 'url(/assets/images/testbackground-plan-de-travail-8.svg)',
             backgroundSize: 'cover',
             backgroundPosition: 'center'
           }}>
        <div className="w-full max-w-6xl flex flex-col md:flex-row gap-8">
          <form onSubmit={handleSubmit(onSubmit)} className="w-full md:w-1/2 bg-white shadow-md rounded-lg px-8 pt-6 pb-8 mb-4">
            <Box className="flex items-center space-x-4 mb-8">
              <img src="/assets/images/logo2.svg" alt="Logo Innovaplus" className="h-16 w-16" />
              <h1 className="ml-3 font-bold text-3xl" style={{ color: theme.palette.primary.main }}>Innovaplus</h1>
            </Box>

            <div className="mb-4">
              <TextField
                fullWidth
                label="Votre Nom & Prénom"
                variant="outlined"
                {...register("clientName", { required: "Merci d'indiquer votre nom & prénom" })}
                error={!!errors.clientName}
                helperText={errors.clientName?.message}
              />
            </div>

            <div className="mb-4">
              <TextField
                fullWidth
                label="Nom de l'entreprise"
                variant="outlined"
                {...register("businessName", { required: "Le nom de l'entreprise est requis" })}
                error={!!errors.businessName}
                helperText={errors.businessName?.message}
              />
            </div>

            <div className="mb-4">
              <TextField
                fullWidth
                label="Email professionnel"
                variant="outlined"
                {...register("contactEmail", { required: "L'email est requis", pattern: { value: /^\S+@\S+$/i, message: "Format d'email invalide" } })}
                error={!!errors.contactEmail}
                helperText={errors.contactEmail?.message}
              />
            </div>

            <div className="mb-4">
              <TextField
                fullWidth
                label="Numéro de téléphone"
                variant="outlined"
                {...register("phone", { required: "Le numéro de téléphone est requis" })}
                error={!!errors.phone}
                helperText={errors.phone?.message}
              />
            </div>

            <div className="mb-4">
              <FormControl fullWidth error={!!errors.service}>
                <InputLabel id="service-label">Service souhaité</InputLabel>
                <Select
                  labelId="service-label"
                  label="Service souhaité"
                  defaultValue=""
                  {...register("service", { required: "Veuillez sélectionner un service" })}
                >
                  <MenuItem value="ai">Solutions IA sur mesure</MenuItem>
                  <MenuItem value="web">Développement Web professionnel</MenuItem>
                  <MenuItem value="e-invoicing">E-Facturation Peppol</MenuItem>
                  <MenuItem value="multiple">Solution intégrée (plusieurs services)</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="mb-4">
              <TextField
                fullWidth
                multiline
                rows={3}
                label="Décrivez brièvement votre projet ou besoin"
                variant="outlined"
                {...register("projectDescription", { required: "Veuillez décrire brièvement votre projet" })}
                error={!!errors.projectDescription}
                helperText={errors.projectDescription?.message}
              />
            </div>

            <div className="mb-4">
              <FormControl fullWidth error={!!errors.budget}>
                <InputLabel id="budget-label">Budget approximatif</InputLabel>
                <Select
                  labelId="budget-label"
                  label="Budget approximatif"
                  defaultValue=""
                  {...register("budget", { required: "Ce champ est requis" })}
                >
                  <MenuItem value="less-5k">Moins de 5.000€</MenuItem>
                  <MenuItem value="5k-15k">5.000€ - 15.000€</MenuItem>
                  <MenuItem value="15k-30k">15.000€ - 30.000€</MenuItem>
                  <MenuItem value="more-30k">Plus de 30.000€</MenuItem>
                  <MenuItem value="undecided">À discuter</MenuItem>
                </Select>
              </FormControl>
            </div>
            
            <Button 
              type="submit" 
              fullWidth 
              variant="contained" 
              color="primary" 
              size="large"
              sx={{ 
                py: 1.5, 
                fontSize: '1.1rem', 
                fontWeight: 'bold',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
              }}
            >
              Soumettre
            </Button>
          </form>

          <div className="w-full md:w-1/2">
            <div className="bg-white shadow-md rounded-lg px-8 pt-6 pb-8 mb-4">
              <Typography variant="h4" component="h2" className="mb-6" style={{ color: theme.palette.primary.main }}>
                Nos Solutions Pour Votre Entreprise
              </Typography>

              <Box className="mb-6">
                <Typography variant="h6" component="h3" className="mb-2 font-bold">
                  Solutions IA sur Mesure
                </Typography>
                <Typography variant="body1" className="mb-3">
                  Développement d'applications intelligentes qui exploitent le machine learning, le traitement du langage naturel et la vision par ordinateur pour automatiser vos processus et extraire des insights de vos données.
                </Typography>
              </Box>

              <Box className="mb-6">
                <Typography variant="h6" component="h3" className="mb-2 font-bold">
                  Développement Web Professionnel
                </Typography>
                <Typography variant="body1" className="mb-3">
                  Sites web modernes et responsive, optimisés pour la performance, l'expérience utilisateur et le référencement, conçus pour atteindre vos objectifs commerciaux.
                </Typography>
              </Box>

              <Box className="mb-6">
                <Typography variant="h6" component="h3" className="mb-2 font-bold">
                  E-Facturation Certifiée Peppol
                </Typography>
                <Typography variant="body1" className="mb-3">
                  Solutions de facturation électronique conformes aux normes Peppol pour simplifier vos processus financiers, réduire les erreurs et accélérer les paiements.
                </Typography>
              </Box>

              <Box className="p-4 bg-gray-100 rounded-lg mb-6">
                <Typography variant="h6" component="h3" className="mb-2 font-bold">
                  Notre Engagement
                </Typography>
                <Typography variant="body1">
                  Dès réception de votre demande, notre équipe d'experts l'analysera et vous contactera dans les 24-48h pour discuter des solutions adaptées à vos besoins spécifiques et établir un plan d'action personnalisé.
                </Typography>
              </Box>
            </div>
          </div>
        </div>
      </div>
    );
}
